/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_AttachmentInputs */

const es_common_attachment = /** @type {(inputs: Common_AttachmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar Adjuntos`)
};

const en_common_attachment = /** @type {(inputs: Common_AttachmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Attachments`)
};

/**
* | output |
* | --- |
* | "Add Attachments" |
*
* @param {Common_AttachmentInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const common_attachment = /** @type {((inputs?: Common_AttachmentInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_AttachmentInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_attachment(inputs)
	return en_common_attachment(inputs)
});
export { common_attachment as "common.attachment" }